import { DEFAULT_TIME_CONTROL_ID, findTimeControl, type TimeControl } from '@chess/core'

/** A preset id from a URL, resolved with the default as the safety net. */
export const resolveTimeControl = (id: string): TimeControl =>
  (findTimeControl(id) ?? findTimeControl(DEFAULT_TIME_CONTROL_ID))?.control ?? {
    kind: 'unlimited',
  }
